import { render, staticRenderFns } from "./modalslide1.vue?vue&type=template&id=201fc634&scoped=true&"
import script from "./modalslide1.vue?vue&type=script&lang=js&"
export * from "./modalslide1.vue?vue&type=script&lang=js&"
import style0 from "./modalslide1.vue?vue&type=style&index=0&id=201fc634&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "201fc634",
  null
  
)

export default component.exports